module.exports = __webpack_public_path__ + "static/media/hall-P5.94f52203.svg";